
import getChartColorsArray from "../../Common/ChartsDynamicColor";
import Chart from 'react-apexcharts'


const PaymentActivityData = ({ categories, data,dataColors }:any) => {
    const chartbarBasicColors = getChartColorsArray(dataColors);

    const series:any = [{
        name: 'Income',
        data: data
    }]

    const options:any = {
        chart: {
            height: 362,
            type: 'bar',
            toolbar: {
                show: false
            },
            zoom: {
                enabled: true
            }
        },

        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '35%',
                endingShape: 'rounded'
            },
        },

        dataLabels: {
            enabled: false
        },
        
        xaxis: {
            categories: categories,
        },
        grid:{
            xaxis: {
                lines: {
                    show: false
                }
            },   
            yaxis: {
                lines: {
                    show: false
                }
            }, 
          },
        colors: chartbarBasicColors,
        legend: {
            show: false
        },
        fill: {
            opacity: 1
        },
    };
    return (
        <Chart
            dir="ltr"
            className="apex-charts"
            series={series}
            options={options}
            type="bar"
            height={362}
        />
    )
  }

export {PaymentActivityData}  